import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { IconPeopleMan1 } from "@americanbible/uikit";

import { useAuthContext } from "../Auth/AuthContext";
import HomeIcon from "../../icons/HomeIcon";
import InfoIcon from "../../icons/InfoIcon";
import FacebookIcon from "../../icons/FacebookIcon";
import TwitterIcon from "../../icons/TwitterIcon";
import Media from "../../utils/media";

const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${Media.desktop`
    flex-direction: row;
  `};
`;

const styleLink = `
  flex: 0 1 auto;
  padding: 0.4em 0.5em;
  margin-right: 10px;
  display: inline-block;
  ${Media.tablet`
    border: none;
    margin: 0;
  `};
`;
const IconAnchor = styled.a`
  ${styleLink}
`;
export const IconLink = styled(Link)`
  ${styleLink}
`;

const IconDividerWrapper = styled.div`
  margin-right: 8px;
  height: 100%;
  display: flex;
  align-items: center;
`;
const IconDivider = styled.div`
  width: 1px;
  height: 24px;
  background: rgba(255, 255, 255, 0.4);
`;

export const SiteLinks = ({ site, theme, toggleDrawer }) => {
  const { isAuthenticated } = useAuthContext();

  if (!site) return null;

  const hasSiteLinks =
    site.linkWebsite ||
    site.description ||
    site.linkFacebook ||
    site.linkTwitter;
  const iconColor = theme.textSecondaryOnPrimary;
  const linkIcons = {
    linkFacebook: FacebookIcon,
    linkTwitter: TwitterIcon
  };

  return (
    <LinksContainer>
      {site.linkWebsite && (
        <IconAnchor
          href={site.linkWebsite}
          target="blank"
          key={site.linkWebsite}
          onClick={toggleDrawer}
          rel="noreferrer noopener"
        >
          <HomeIcon size={25} color={iconColor} />
        </IconAnchor>
      )}
      {site.description && (
        <IconLink to="/info" onClick={toggleDrawer}>
          <InfoIcon size={25} color={iconColor} />
        </IconLink>
      )}
      {Object.keys(linkIcons).map(link => {
        const Icon = linkIcons[link];
        const target = site[link];

        if (!target) return null;

        return (
          <IconAnchor
            href={target}
            target="_blank"
            key={link}
            onClick={toggleDrawer}
            rel="noreferrer noopener"
          >
            <Icon size={25} color={iconColor} />
          </IconAnchor>
        );
      })}
      {site.enabledUserAccounts && (
        <>
          {hasSiteLinks && (
            <IconDividerWrapper>
              <IconDivider />
            </IconDividerWrapper>
          )}
          <IconLink to={isAuthenticated ? "/user-settings" : "/auth"}>
            <IconPeopleMan1 color={iconColor} />
          </IconLink>
        </>
      )}
    </LinksContainer>
  );
};
